import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import AdminStatsPage from "./pages/AdminStatsPage";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<LandingPage />} />
                    <Route path="/admin/stats" element={<AdminStatsPage />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
